import * as React from 'react'

import { ResourceCard } from '~/client/src/shared/components/ResourceCardList/ResourceCard'
import ResourceCardList from '~/client/src/shared/components/ResourceCardList/ResourceCardList'
import ResourceCardListGroupHeader from '~/client/src/shared/components/ResourceCardList/ResourceCardListGroupHeader'

import {
  useMobileResourceActions,
  useMobileResourceMeta,
  useMobileResourceState,
} from '../context'
import { LayoutProps } from './types'

export const MobileResourceList: React.FC<LayoutProps> = ({ className }) => {
  const {
    filteredRecords,
    cardConfiguration,
    properties,
    getDisplayValue,
    resolveMetaItem,
    resolveSubtitle,
    resolveLeadingSlot,
    groupConfig,
    grouping,
    loading,
  } = useMobileResourceState()
  const { selectRecord } = useMobileResourceActions()
  const { resourceTypeId, countLabel, emptyMessage } = useMobileResourceMeta()

  return (
    <ResourceCardList
      resourceTypeId={resourceTypeId}
      records={filteredRecords}
      cardConfiguration={cardConfiguration}
      properties={properties}
      getDisplayValue={getDisplayValue}
      resolveMetaItem={resolveMetaItem}
      resolveSubtitle={resolveSubtitle}
      loading={loading}
      emptyMessage={emptyMessage}
      className={className}
      countLabel={countLabel}
      groupConfig={groupConfig}
      renderGroupHeader={(group, toggle) => (
        <ResourceCardListGroupHeader
          group={group}
          onToggle={toggle}
          grouping={grouping}
          properties={properties}
          resourceTypeId={resourceTypeId}
        />
      )}
    >
      {(record, model) => (
        <ResourceCard.Standard
          model={model}
          variant="menu"
          className="tw:transition-colors tw:active:bg-accent-soft"
          leading={resolveLeadingSlot?.(record)}
          onClick={() => selectRecord(record.id)}
        />
      )}
    </ResourceCardList>
  )
}
